import type { OrganisationRow, OrganisationsAnswer } from "@hakili/contracts";

import type { Partner } from "../routes/dealerships.js";

/**
 * `P0-CNW-029`: what `GET /api/v1/organisations` answers, from the contract's columns to the directory's own names.
 *
 * **`A48` is why this file stopped guessing.** `identityFrom` was written the other way once , the client read
 * `fullName` at the top level while the server had nested it under `profile` since `P0-IDN-012` , and the two never
 * agreed for a year without a single error anywhere, because a cast makes a wrong shape look like an empty one. This
 * file then checked every field by hand, which was a second description of the row. `GENERIC-DOOR-SWEEP`, Arc 1 gave the
 * row ONE description: {@link OrganisationRow} in `@hakili/contracts`, the type the door is returned by and the schema an
 * integration spec parses the door's real answer with. What is left here is only the renaming: the wire's SQL names
 * (`member_count`, `opened_by_name`) to the directory's (`memberCount`, `openedByName`), and the two counts the wire
 * sends as text (`count(*)::text`) to numbers.
 *
 * **`administrator` is an object (there is a person) or `null` (the api says there is none).** Both are on the wire and
 * the contract names both; a screen renders them differently.
 */
function partnerFrom(row: OrganisationRow): Partner {
  return {
    id: row.id,
    name: row.name,
    type: row.type,
    administrator: row.administrator,
    status: row.status,
    openedByName: row.opened_by_name,
    managerName: row.manager_name,
    memberCount: Number(row.member_count),
    activeCount: Number(row.active_count),
    invitationPendingSince: row.invitation_pending_since,
  };
}

export const partnersFrom = (answer: OrganisationsAnswer): readonly Partner[] => answer.data.map(partnerFrom);
